import { getId } from '@/helpers';
import apiService from './api_layer';

export const calls = {
  load_current_call: () => apiService.get('/calls/current'),
  load_calls: () => apiService.get('/calls'),
  get_call: (call_id) => apiService.get(`/calls/${call_id}`),
  save_new_call: (call) => apiService.put('/calls', call),
  save_call_changes: (call) => apiService.post(`/calls/${getId(call)}`, call),
  submit_new_call: (call) => apiService.patch('/calls', call),
  submit_call: (call) => apiService.patch(`/calls/${getId(call)}`, call),
  remove_call: (call) => apiService.delete(`/calls/${getId(call)}`),
};

export const config = {
  loadConfig: (configName) => apiService.get(`/config/${configName}`),
  saveConfig: (conf) => apiService.put(`/config/${conf.name}`, conf),
};

export const users = {
  load_self_affiliations: () => apiService.get('/affiliations/me'),
  loadSelfConsents: () => apiService.get('users/me/consents'),
  updateSelfConsents: (consents) => apiService.post('users/me/consents', consents),
};

export const reviewers = {
  loadReviewersSynchrotron: () => apiService.get('/users/roles/reviewer', { params: { inactive_excluded: 'False' } }),
  loadReviewersRapidAccessSynchrotron: () => apiService.get(
    '/users/roles/rapid-access/reviewer/synchrotron',
    { params: { inactive_excluded: 'False' } },
  ),
  loadReviewersCryoem: () => apiService.get('/users/roles/reviewer/cryoem', { params: { inactive_excluded: 'False' } }),
};

export const calendar = {
  submitDocumentReservations: (objectId, dates) => apiService.post(`/documents/${objectId}/cryoem/reservations`, dates),
  loadCalendarConfig: (infrastructure) => apiService.get(`/config/${infrastructure}/calendar`),
  loadCalendarReservations: (infrastructure) => apiService.get(`/documents/${infrastructure}/reservations`),
  submitCalendarConfigDates: (infrastructure, data) => apiService.post(
    `/config/${infrastructure}-calendar/dates`,
    data,
  ),
};

export const proposalForm = {
  submitProposal: (objectId, proposal) => apiService.patch(`/documents/${objectId}`, proposal),
  submitRapidAccessProposal: (objectId, proposal) => apiService.patch(`/documents/${objectId}/rapid-access`, proposal),
};

export const rapidAccessTechnicalEvaluation = {
  // temporary solution - pathSegment to delete in all 3 places when changing cryo RA inhouse_grade into technical_eval
  loadRapidAccessTechnicalEvaluationProposals: (infrastructure) => {
    const pathSegment = infrastructure === 'cryoem' ? 'inhouse-grade' : 'technical';
    return apiService.get(`/documents/rapid-access/${pathSegment}/${infrastructure}`);
  },
  saveRapidAccessProposalTechnicalEvaluation:
  // eslint-disable-next-line vue/max-len
    (proposalId, infrastructure, evaluation) => {
      const pathSegment = infrastructure === 'cryoem' ? 'inhouse-grade' : 'technical';
      return apiService.post(`/documents/rapid-access/${proposalId}/${pathSegment}/${infrastructure}`, evaluation);
    },
  submitRapidAccessProposalTechnicalEvaluation:
    (proposalId, infrastructure) => {
      const pathSegment = infrastructure === 'cryoem' ? 'inhouse-grade' : 'technical';
      return apiService.patch(
        `/documents/rapid-access/${proposalId}/${pathSegment}/${infrastructure}`,
      );
    },
};

export const usersMePrivileges = {
  loadUsersMePrivilege: (privilegeId) => apiService.get(`/users/me/privileges/${privilegeId}`),
  updateUsersMePrivilegeState:
    (privilegeId, privilegeState) => apiService.patch(`/users/me/privileges/${privilegeId}`, { privilegeState }),
};
